import React, { Component } from 'react';

import HeaderBlock from '../../components/HeaderBlock';
import CardList from '../../components/CardList';
import Header from '../../components/Header';
import Paragraph from '../../components/Paragraph';
import database from '../../services/firebase';
// import ReactLogo from '../../logo.svg'
import { ReactComponent as ReactLogo } from '../../logo.svg';

import s from './Home.module.scss';

class HomePage extends Component {
	state = { 
		wordArr: [],
	}

	urlRequest = `/cards/${this.props.user.uid}`;

	componentDidMount() {
		database.ref(this.urlRequest).on('value', res => {
			this.setState({
				wordArr: res.val() || [],
			});
		})
	}

	handleSubmitButton = ({eng, rus}) => {
		const {wordArr} = this.state;
		database.ref(this.urlRequest).set([...wordArr, {
			id: +new Date(),
			eng,
			rus,
		}], () => {
			console.log('####: Callbacks')
		})
	}

	setNewWord = () => {
		// const { wordArr } = this.state;
		database.ref('/cards'+ this.state.wordArr.length).set({
			eng: 'mouse',
			rus: 'мышь',
			id: Math.floor(Math.random() * Math.floor(100))
		})
	}

	handleInputChange = ( { target } ) => {
		this.setState({
			value: target.value,
		})
	}

	handleSubmitForm = (e) => {
		e.preventDefault();
	}



	handleDeletedItem = (id) => {
		const { wordArr } = this.state;

		const newWordArr = wordArr.filter(item => item.id !== id);
		database.ref(this.urlRequest).set(newWordArr);
	}

	render() { 
		const { wordArr } = this.state;
		return (
			<>
				<div>
					<HeaderBlock className='container'>
						<Header>
							Время учить слова онлайн
						</Header>
						<Paragraph>
							Используйте карточки для запоминания и пополняйте активный словарный запас.
						</Paragraph>
						<button 
							className={s.button}
							onClick={() => {
								this.refInput.current.focus();
							}}
						>Начать изучать</button>
					</HeaderBlock>
					<CardList
						className={s.container}
						refEngInput={el => this.refInput = el}
						onSubmit={this.handleSubmitButton}
						onDeletedItem={this.handleDeletedItem}
						item={wordArr} 
					/>
	
					<HeaderBlock hideBackground>
						<Header>
							Еще один заголовок
						</Header>
						<Paragraph>
							Ну здорово же!
						</Paragraph>
						<ReactLogo />
					</HeaderBlock>
				</div>
			</>
		)
	}
}
 
export default HomePage;